export default {
  name: 'Extension Panning',
  buttons: [
    {
      title: 'Panning',
      key: '[Space / mouse wheel + drag]'
    }
  ]
}
